import {createStore} from 'redux';

const state = {
	nodo_empresa:'',
	nombre_empresa:'',
	data_report:[],
	labels_report:[],
	tipo_reporte:'',
	mostrar:'noMostrar',
	ruta: {}, 
	empresa:'',
	programacionDia: {},
	endpoints:{}
};

const reducer = (state , action ) =>{
	switch(action.type){
		case 'STATE_EMPRESA':
			return {
				...state,
				nodo_empresa:action.nodo_empresa,
				nombre_empresa:action.nombre_empresa			
			};	
		
		case 'STATE_REPORT':
			return{			
				...state,
				data_report:action.data_report,
				labels_report:action.labels_report,
				tipo_reporte:action.tipo_reporte
			};

		case 'STATE_MOSTRAR':
			return{			
				...state,
				mostrar:action.mostrar		
			}	

		case 'SET_RUTA':
			return {
				...state,
				ruta: action.payload
			}

		case 'SET_PROGRAMACION':
			return {
				...state,
				programacionDia: action.payload
			}

		case 'SET_EMPRESA':
			return {
				...state,
				empresa: action.payload
			}
		case 'SET_ENPOINTS': 
			return {
				...state,
				endpoints: action.payload
			}
		default:
			return state
	}
}
export default createStore(reducer, state);


// WEBPACK FOOTER //
// ./src/store.js